export default __webpack_public_path__ + "static/media/row_one.9e68ab15.png";